import { render } from "./PowerSolutionBlock.vue?vue&type=template&id=51093a40&scoped=true&ts=true"
import script from "./PowerSolutionBlock.vue?vue&type=script&lang=ts"
export * from "./PowerSolutionBlock.vue?vue&type=script&lang=ts"

import "./PowerSolutionBlock.vue?vue&type=style&index=0&id=51093a40&lang=scss&scoped=true"

import exportComponent from "E:\\agent\\azdo\\CI\\a1-CI\\_work\\133\\s\\src\\MagnetoEnergy.Vue.WebClient\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51093a40"]])

export default __exports__